import React, { Component } from "react";
import SelectorAccordionGroupContainer from "./SelectorAccordionGroupContainer";
import SelectorAccordionGroup from "./SelectorAccordionGroup";
import SelectorAccordionItem from "./SelectorAccordionItem";
import { camelToName } from "../../../helpers/stringHelpers";

class SelectorAccordionList extends Component {
  state = {
    openGroup: null,
    openTypeGroup: null
  };

  componentDidMount(){
    this.setState({ openGroup: null, openTypeGroup: null,})
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.config && nextProps.config.alias !== this.props.config.alias){
      this.setState({ openGroup: null, openTypeGroup: null,})
    }
  }

  handleOpenGroup = (name) => {
    document.getElementsByClassName("sidebar-content-in")[0].scrollTo(0,0)
    if (name === this.state.openGroup){
      this.setState({ openGroup: null })
    } else {
      this.setState({ openGroup: name })
    }
  }

  handleOpenTypeGroup = (name) => {
    document.getElementsByClassName("sidebar-content-in")[0].scrollTo(0,0)
    if (name === this.state.openTypeGroup){
      this.setState({ openTypeGroup: null, openGroup: null  })
    } else {
      this.setState({ openTypeGroup: name, openGroup: null  })
    }
  }

  renderSelectorAccordionGroups = (atomsTypes, typeName) => {
    const {
      config,
      onAtomSelect,
      currentSubStepSelectedAtom,
      getIconImage,
      checkEnabledLevel
    } = this.props;

    const newAtomsTypes = []
    //eccezione concatena liste di atomi con alias
    atomsTypes.forEach((atomType, index) => {
      if (atomsTypes[index - 1] && atomsTypes[index] && atomsTypes[index - 1].visibleName === atomsTypes[index].visibleName){
        atomsTypes[index].list.forEach((item) => {
          if (!newAtomsTypes[index - 1].list.find(itemB => (itemB.alias === item.alias))){
            newAtomsTypes[index - 1].list.push(item)
          }
        })
      } else {
        newAtomsTypes.push({ ...atomType });
      }
    })

    return newAtomsTypes.map((atomType, index) => {
      return (
        <SelectorAccordionGroup
          extraPadding={config.showTypes}
          atom
          key={atomType.name + new Date().getTime()}
          name={atomType.visibleName}
          open={this.state.openGroup === atomType.name}
          handleOnClick={() => this.handleOpenGroup(atomType.name)}
        >
          {atomType.list ? (
            atomType.list.map((atom, index) => {

              const selected = currentSubStepSelectedAtom.alias === atom.alias && currentSubStepSelectedAtom.type === typeName ;
              const disabled = !checkEnabledLevel(atom, typeName)
              return (
                <SelectorAccordionItem
                  disabled={disabled}
                  img={getIconImage(atom.alias)}
                  selected={selected}
                  key={atom.alias + "-" + index + new Date().getTime() + index}
                  atom={atom}
                  onAtomSelect={() => onAtomSelect(atom, typeName, config.link)}
                />
              );
            })
          ) : (
            <div>loading</div>
          )}
        </SelectorAccordionGroup>
      );
    });
  };

  renderSelectorAccordionGroupContainers = atoms => {
    const { config } = this.props;
    
    return atoms.map(type => {
      return (
        <SelectorAccordionGroupContainer
          open={!config.showTypes || this.state.openTypeGroup === type.name}
          showName={config.showTypes}
          key={type.name + new Date().getTime()}
          name={camelToName(type.name)}
          handleOnClick={() => this.handleOpenTypeGroup(type.name)}
        >
          {this.renderSelectorAccordionGroups(type.atoms, type.alias)}
        </SelectorAccordionGroupContainer>
      );
    });
  };

  render() {
    const { atoms } = this.props;
    return (
      <div className="selector-accordion-list">
        {atoms
          ? this.renderSelectorAccordionGroupContainers(atoms)
          : "nessun elemento da mostrare"}
      </div>
    );
  }
}

export default SelectorAccordionList;
